import { Component } from 'react'
import { GlobalErrorOverlay } from './global-error-overlay'
import type { ErrorInfo, ReactNode } from 'react'
import { captureException } from '@/lib/glitchtip'

interface ErrorBoundaryProps {
  children: ReactNode
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (import.meta.env.DEV) {
      // Log mais verboso apenas em desenvolvimento
      console.error('[ErrorBoundary] Erro capturado:', error, errorInfo)
    } else {
      console.error('[ErrorBoundary] Erro capturado:', error)
    }

    captureException(error, {
      componentStack: errorInfo.componentStack,
      origin: 'ErrorBoundary',
    })

    // Callback opcional para quem envolver manualmente com ErrorBoundary
    this.props.onError?.(error, errorInfo)
  }

  private handleReload = () => {
    window.location.reload()
  }

  private handleGoHome = () => {
    window.location.href = '/workspace'
  }

  render() {
    if (this.state.hasError) {
      return (
        <GlobalErrorOverlay
          isVisible
          onReload={this.handleReload}
          onGoHome={this.handleGoHome}
        />
      )
    }

    return this.props.children
  }
}

